import { render, staticRenderFns } from "./Petition.vue?vue&type=template&id=40645d2a&scoped=true"
import script from "./Petition.vue?vue&type=script&lang=js"
export * from "./Petition.vue?vue&type=script&lang=js"
import style0 from "./Petition.vue?vue&type=style&index=0&id=40645d2a&prod&lang=scss&scoped=true"
import style1 from "./Petition.vue?vue&type=style&index=1&id=40645d2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40645d2a",
  null
  
)

export default component.exports